import { withStyles } from '@mui/styles'

export const GlobalCss = withStyles(theme => ({
    '@global': {
        'html, #root': {
            height: '100%',
        },
        '#date-picker-portal': {
            position: 'absolute !important',
            width: '100%',
            zIndex: 1001,
        },
        body: {
            margin: 0,
            height: '100%',
            fontFamily: 'Roboto',
        },
        '.MuiFormControl-root': {
            width: '100%',
            minWidth: '60px !important',
        },
        '#scrollElement::-webkit-scrollbar': {
            width: 6,
            backgroundColor: 'transparent',
        },

        '#scrollElement::-webkit-scrollbar-thumb': {
            borderRadius: 10,
            backgroundColor: theme.palette.primary.main,
        },

        '#scrollElement::-webkit-scrollbar-track': {
            borderRadius: 10,
            backgroundColor: theme.palette.secondary.main,
            border: '0.5px solid transparent',
            backgroundClip: 'content-box',
        },
    },
}))(() => null)
